import { DashboardBaseSteps, DashboardPurchasingSteps } from "./DashboardSteps";
import { EditProductsSteps } from "./EditProductsSteps";
import { ProductsSteps } from "./ProductsSteps";
import { SupplierProductsSteps } from "./SupplierProductsSteps";

const TourStepMapping = {
    Products: ProductsSteps,
    EditProduct: EditProductsSteps,
    Dashboard: DashboardBaseSteps,
    "Purchasing Intro": DashboardPurchasingSteps,
    SupplierProducts: SupplierProductsSteps,
  };
  
  export default TourStepMapping;